import { createContext } from 'react';

import { useContextSelector } from '@ui/hooks/useStoreSelector';
import useBondDirectorySearch from '../hooks/useBondDirectorySearch';

export const BondDirectoryContext = createContext();

export const BondDirectoryProvider = ({ children }) => {
    const { states, callbacks, services } = useBondDirectorySearch();

    return (
        <BondDirectoryContext.Provider
            value={{
                states,
                callbacks,
                services,
            }}
        >
            {children}
        </BondDirectoryContext.Provider>
    );
};

export const useBondDirectoryContext = (selector) =>
    useContextSelector(BondDirectoryContext, selector);
